var React = require('react');

function CariesRiskAnalysis (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.3725 12L20.7771 9.59532L12.1818 1L3.58651 9.59532L5.99119 12M3.58651 14.4047L12.1818 5.80936L20.7771 14.4047L12.1818 23L3.58651 14.4047ZM7.37244 14.4047L12.1818 9.59529L16.9912 14.4047L12.1818 19.2141L7.37244 14.4047Z","stroke":"currentColor","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CariesRiskAnalysis.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = CariesRiskAnalysis;

CariesRiskAnalysis.default = CariesRiskAnalysis;
